import React from "react";
import MuiSideFilter from "../Pages/Grid/Components/MuiSideFilter";
import { useDispatch, useSelector } from "react-redux";
import { setDirections, setGridDirection, setOpenSideSetting } from "../reduxStore/SettingsReducer";
import { Box, IconButton, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Background } from "devextreme-react/range-selector";
import CloseIcon from "@mui/icons-material/Close";

export default function SideSetting() {
  const [t] = useTranslation("common");
  const dispatch = useDispatch();
  const openSideSetting = useSelector(
    (state) => state.settingsData.openSideSetting
  );
  const main_translation = useSelector(
    (state) => state.translateData.main_translation
  );
  const gridDirection = useSelector((state) => state.settingsData.gridDirection);

  const getColors = (direction) => {
    let darkcolorActive = "#1e6a99";
    let lightcolorActive = "#1e6a99a0";
    let darkcolorNone = "#a7a2a2";
    let lightcolorNone = "#b9b9b9";

    if (gridDirection == direction) {
      return { dark: darkcolorActive, light: lightcolorActive };
    } else {
      return { dark: darkcolorNone, light: lightcolorNone };
    }
  };
  return (
    <MuiSideFilter
      open={openSideSetting}
      setOpen={(value) => {
        dispatch(setOpenSideSetting(false));
      }}
      width="265px !important"
      backgroundColor="rgba(255, 255, 255, 0.9)"
      boxShadow="rgba(145, 158, 171, 0.24) -40px 40px 80px -8px"
    >
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "60px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0 10px",
            borderBottom: " 2px dotted #d6d6d6",
          }}
        >
          <span>{main_translation?.SIDESETTINGS?.title}</span>
          <Tooltip title={main_translation?.SIDESETTINGS?.close}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                dispatch(setOpenSideSetting(false));
              }}
            >
              <CloseIcon />
            </Box>
          </Tooltip>
        </Box>
        <Box
          sx={{
            width: "100%",
            // height:'60px',
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "flex-start",
            padding: "0 10px",
            marginTop: "20px",
            // borderBottom:" 2px dotted #d6d6d6",
          }}
        >
          <span>{main_translation?.SIDESETTINGS?.directions}</span>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop:'10px'
            }}
          >
            <IconButton
              sx={{
                width: "48%",
                height: "70px",
                border: "1px solid grey",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "5px",
                overflow: "hidden",
                "&:hover": {
                  backgroundColor: "#1e6a991f",
                },
              }}
              onClick={()=>{
                dispatch(setGridDirection('ltr'))
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "60px",
                  height: "50px",
                }}
              >
                <span
                  style={{
                    width: "13px",
                    height: "80%",
                    backgroundColor: getColors('ltr')?.dark,
                    margin: "0 2px",
                    borderRadius: "4px",
                  }}
                ></span>
                <Box
                  sx={{
                    width: "78%",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    flexDirection: "column",
                    margin: "0 2px",
                  }}
                >
                  <span
                    style={{
                      width: "70%",
                      height: "12px",
                      backgroundColor:getColors('ltr')?.light,
                      borderRadius: "4px",
                      margin: "2px 0",
                    }}
                  ></span>
                  <span
                    style={{
                      width: "100%",
                      height: "12px",
                      backgroundColor:getColors('ltr')?.light,
                      borderRadius: "4px",
                      margin: "2px 0",
                    }}
                  ></span>
                </Box>
              </Box>
            </IconButton>
            <IconButton
              sx={{
                width: "48%",
                height: "70px",
                border: "1px solid grey",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "5px",
                overflow: "hidden",
                "&:hover": {
                  backgroundColor: "#1e6a991f",
                },
              }}
              onClick={()=>{
                dispatch(setGridDirection('rtl'))
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "row-reverse",
                  width: "60px",
                  height: "50px",
                }}
              >
                <span
                  style={{
                    width: "13px",
                    height: "80%",
                    backgroundColor: getColors('rtl')?.dark,
                    margin: "0 2px",
                    borderRadius: "4px",
                  }}
                ></span>
                <Box
                  sx={{
                    width: "78%",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-end",
                    flexDirection: "column",
                    margin: "0 2px",
                  }}
                >
                  <span
                    style={{
                      width: "70%",
                      height: "12px",
                      backgroundColor: getColors('rtl')?.light,
                      borderRadius: "4px",
                      margin: "2px 0",
                    }}
                  ></span>
                  <span
                    style={{
                      width: "100%",
                      height: "12px",
                      backgroundColor: getColors('rtl')?.light,
                      borderRadius: "4px",
                      margin: "2px 0",
                    }}
                  ></span>
                </Box>
              </Box>
            </IconButton>
          </Box>
        </Box>
      </Box>
    </MuiSideFilter>
  );
}
